/* Leia & Batce — "Your codes" chips (LAB-39). Plain script, no imports.
   Drives Horizon's cart-discount-component: apply = fill its input + submit; remove = click its pill ✕.
   State: localStorage lb_codes (held), sessionStorage lb_codes_bad (rejected this session). */
(function () {
  if (window.__lbCodes) return;
  window.__lbCodes = true;

  var KEY = 'lb_codes', BAD = 'lb_codes_bad';
  function read(store, k) { try { return JSON.parse(store.getItem(k) || '[]'); } catch (e) { return []; } }
  function write(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function norm(c) { return String(c || '').trim().toUpperCase(); }
  // 2026-09-26 (run4-pdp-v1): the popup watcher must work on pages where the drawer's codes row is not rendered
  // (empty cart), so `known` has a root-less fallback — LAB10 is the code the popup hands out.
  var FALLBACK_KNOWN = ['LAB10'];
  function known(root) { return root ? (root.dataset.known || '').split(',').map(norm).filter(Boolean) : FALLBACK_KNOWN; }

  function hold(code, root) {
    code = norm(code);
    if (!code || known(root).indexOf(code) === -1) return;
    var held = read(localStorage, KEY);
    if (held.indexOf(code) === -1) { held.push(code); write(localStorage, KEY, held); }
  }

  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function drawer() { return document.getElementById('cart-drawer'); }
  function component() { var d = drawer(); return d && d.querySelector('cart-discount-component'); }
  function appliedCodes() {
    var c = component(); if (!c) return [];
    return Array.prototype.map.call(c.querySelectorAll('.cart-discount__pill'), function (p) { return norm(p.dataset.discountCode); });
  }

  function apply(code) {
    var c = component(); if (!c) return;
    var form = c.querySelector('.cart-discount__form'), input = c.querySelector('input[name="discount"]');
    if (!form || !input) return;
    var details = c.closest('details'); if (details) details.open = true;
    input.value = code;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    // if the theme shows its error, remember the code as not valid for this cart (this session)
    setTimeout(function () {
      var err = c.querySelector('[ref="cartDiscountErrorDiscountCode"]');
      if (err && !err.classList.contains('hidden')) {
        var bad = read(sessionStorage, BAD); if (bad.indexOf(code) === -1) { bad.push(code); write(sessionStorage, BAD, bad); }
        render();
      }
    }, 1800);
  }

  function remove(code) {
    var c = component(); if (!c) return;
    var pill = Array.prototype.find.call(c.querySelectorAll('.cart-discount__pill'), function (p) { return norm(p.dataset.discountCode) === code; });
    var btn = pill && pill.querySelector('.cart-discount__pill-remove');
    if (btn) btn.click();
  }

  // signup-code-v1 S2 (LAB-157, owner 10-18): a sign-up's code reaches checkout without typing. Shopify's discount
  // link sets the code for this browser's checkout (express buttons included); once per session per code.
  function link(code, source) {
    code = norm(code);
    if (!code || FALLBACK_KNOWN.indexOf(code) === -1) return;
    var done = read(sessionStorage, 'lb_codes_linked');
    if (done.indexOf(code) !== -1) return;
    done.push(code); write(sessionStorage, 'lb_codes_linked', done);
    try { if (window.posthog && window.posthog.capture) window.posthog.capture('lb_signup_code', { source: source, code: code }); } catch (e) {}
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fpolicies%2Fterms-of-service', { credentials: 'same-origin' })
      .then(function () { init(); autoApply(); })
      .catch(function () {});
  }
  function footerSignup() {
    var el = document.querySelector('[data-lb-signup-code]'); if (!el) return;
    var code = el.dataset.lbSignupCode;
    hold(code, null); link(code, 'footer'); render();
  }

  var lastSig = '';
  function render() {
    var root = drawer() && drawer().querySelector('[data-lb-codes]'); if (!root) return;
    var list = root.querySelector('[data-lb-codes-list]');
    var applied = appliedCodes(), bad = read(sessionStorage, BAD);
    var held = read(localStorage, KEY).concat((root.dataset.customerCodes || '').split(',')).map(norm).filter(Boolean);
    var all = []; applied.concat(held).forEach(function (c) { if (c && all.indexOf(c) === -1) all.push(c); });
    // only touch the DOM when the state actually changed (our own writes must not re-trigger us)
    var sig = all.join(',') + '|' + applied.join(',') + '|' + bad.join(',') + '|' + (list.children.length);
    if (sig === lastSig && (root.hidden === !all.length)) return;
    lastSig = sig;
    if (!all.length) { root.hidden = true; return; }
    root.hidden = false;
    list.innerHTML = '';
    all.forEach(function (code) {
      var li = document.createElement('li'); li.className = 'lb-codes__chip';
      var isOn = applied.indexOf(code) !== -1, isBad = !isOn && bad.indexOf(code) !== -1;
      if (isOn) li.classList.add('lb-codes__chip--on');
      if (isBad) li.classList.add('lb-codes__chip--bad');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'lb-codes__btn';
      b.textContent = code;
      b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      b.setAttribute('aria-label', isOn ? code + ' applied. Remove' : isBad ? code + ' is not valid for this cart' : 'Apply ' + code);
      if (isBad) b.disabled = true;
      b.addEventListener('click', function () { if (isOn) remove(code); else apply(code); });
      li.appendChild(b);
      var s = document.createElement('span'); s.className = 'lb-codes__state';
      s.textContent = isOn ? 'Applied ×' : isBad ? 'Not valid for this cart' : 'Tap to apply';
      li.appendChild(s);
      list.appendChild(li);
    });
  }

  var autoTried = false;
  function autoApply() {
    if (autoTried) return;
    var root = drawer() && drawer().querySelector('[data-lb-codes]'); if (!root || !component()) return;
    var applied = appliedCodes(); if (applied.length) { autoTried = true; return; }
    var bad = read(sessionStorage, BAD);
    var held = read(localStorage, KEY).concat((root.dataset.customerCodes || '').split(',')).map(norm).filter(function (c) { return c && bad.indexOf(c) === -1; });
    held = held.filter(function (c, i) { return held.indexOf(c) === i; });
    if (held.length === 1 && document.querySelector('.cart-form')) { autoTried = true; apply(held[0]); }
  }

  // Welcome popup: the Forms embed renders inside a shadow root; watch its text for a known code. Installed on
  // every page (2026-09-26) — it used to live inside init(), which returns early whenever the drawer's codes row is
  // absent, so a popup submission on a first visit with an empty cart was captured nowhere. The embed mounts late
  // (2nd page view + delay), so the document is watched until it appears.
  function watchEmbed(embed) {
    if (!embed || !embed.shadowRoot || embed.__lbWatched) return;
    embed.__lbWatched = true;
    new MutationObserver(function () {
      var t = embed.shadowRoot.textContent || '';
      var root = drawer() && drawer().querySelector('[data-lb-codes]');
      known(root).forEach(function (k) { if (t.indexOf(k) !== -1) { hold(k, root); link(k, 'tab'); render(); } });
    }).observe(embed.shadowRoot, { childList: true, subtree: true, characterData: true });
  }
  function watchForms() {
    watchEmbed(document.querySelector('shopify-forms-embed'));
    if (window.__lbFormsDocWatch) return;
    window.__lbFormsDocWatch = true;
    var mo = new MutationObserver(function () {
      var e = document.querySelector('shopify-forms-embed');
      if (e && e.shadowRoot) { watchEmbed(e); mo.disconnect(); }   // one lookup per mutation until the embed mounts, then stop
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    var root = drawer() && drawer().querySelector('[data-lb-codes]'); if (!root) return;
    hold(cookieCode(), root);                                   // /discount/CODE visit
    appliedCodes().forEach(function (c) { hold(c, root); });     // codes already in the cart
    watchForms();
    render();
  }

  // simgym-v1 (LAB-195): the drawer's first-order row and "Have a code?" (assets/lb-simgym.js) drive the same paths
  window.lbCodes = {
    hold: function (code) { hold(code, drawer() && drawer().querySelector('[data-lb-codes]')); render(); },
    link: link,
    apply: function (code) { apply(norm(code)); },
    applied: appliedCodes,
    lastError: function () {
      var c = component(), e = c && c.querySelector('[ref="cartDiscountErrorDiscountCode"]');
      return !!(e && !e.classList.contains('hidden'));
    }
  };

  function onReady() {
    watchForms();
    footerSignup();
    init();
    var d = drawer(); if (!d) return;
    // the drawer body is morphed on every cart change; re-render chips after each change
    new MutationObserver(function (records) {
      // ignore our own writes inside the chips row
      var external = records.some(function (r) { return !(r.target instanceof Element && r.target.closest && r.target.closest('[data-lb-codes]')); });
      if (!external) return;
      clearTimeout(window.__lbCodesT); window.__lbCodesT = setTimeout(function () { init(); }, 150);
    }).observe(d, { childList: true, subtree: true });
    d.addEventListener('toggle', function () { setTimeout(function () { init(); autoApply(); }, 250); }, true);
    new MutationObserver(function () { if (d.hasAttribute('open')) setTimeout(function () { init(); autoApply(); }, 250); })
      .observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
